import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table'

type Props = {
  open: boolean
  setOpen: (open: boolean) => void
}

export const StateInfoModal = ({ open, setOpen }: Props) => {
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="sm:max-w-[625px] bg-white">
        <DialogHeader>
          <DialogTitle>状態の説明</DialogTitle>
        </DialogHeader>
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead className="w-[200px]">状態</TableHead>
              <TableHead className="w-[425px]">説明</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            <TableRow>
              <TableCell className="font-medium w-[200px]">
                未使用品に近い
              </TableCell>
              <TableCell className="w-[425px]">
                新品と同様の状態のアイテム
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className="font-medium w-[200px]">
                目立つ傷や汚れがない
              </TableCell>
              <TableCell className="w-[425px]">
                少しの着用感があるものの、目立つ傷や汚れがないアイテム
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className="font-medium w-[200px]">
                やや傷や汚れあり
              </TableCell>
              <TableCell className="w-[425px]">
                一部に傷や汚れがあるアイテム
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </DialogContent>
    </Dialog>
  )
}
